import * as Phaser from 'phaser';
import { PALETTE } from '../render/palette';

export class LightSource extends Phaser.GameObjects.Container {
  constructor(
    scene: Phaser.Scene,
    cellSize: number,
    gridX: number,
    gridY: number,
    direction: 'N' | 'S' | 'E' | 'W',
  ) {
    super(scene, (gridX + 0.5) * cellSize, (gridY + 0.5) * cellSize);

    // All radii scale with cellSize so the entity looks the same proportion at
    // ICON sizes (how-to demos, cellSize=48) and on the puzzle grid (cell=64).
    const rOuterHalo = cellSize * 0.44;
    const rMidHalo = cellSize * 0.28;
    const rBody = cellSize * 0.19;
    const rCore = cellSize * 0.0625;
    const coreOffset = cellSize * 0.047;
    const arrowOffset = cellSize * 0.22;
    const arrowLen = cellSize * 0.125;
    const arrowHalfW = cellSize * 0.0625;

    // Outer pulsing halo — animates to suggest the source is alive.
    const outerHalo = scene.add
      .circle(0, 0, rOuterHalo, PALETTE.LIGHTSOURCE_BODY, 0.6)
      .setOrigin(0.5);
    scene.tweens.add({
      targets: outerHalo,
      alpha: { from: 0.5, to: 0.85 },
      scaleX: { from: 1, to: 1.12 },
      scaleY: { from: 1, to: 1.12 },
      duration: 1700,
      yoyo: true,
      repeat: -1,
      ease: 'Sine.easeInOut',
    });
    outerHalo.setBlendMode(Phaser.BlendModes.ADD);

    const midHalo = scene.add
      .circle(0, 0, rMidHalo, PALETTE.LIGHTSOURCE_BODY, 0.18)
      .setOrigin(0.5)
      .setBlendMode(Phaser.BlendModes.ADD);

    const body = scene.add.circle(0, 0, rBody, PALETTE.LIGHTSOURCE_BODY).setOrigin(0.5);
    const core = scene.add
      .circle(-coreOffset, -coreOffset, rCore, PALETTE.LIGHTSOURCE_CORE, 0.75)
      .setOrigin(0.5);

    const arrow = scene.add.triangle(
      arrowOffset,
      0,
      0,
      -arrowHalfW,
      arrowLen,
      0,
      0,
      arrowHalfW,
      PALETTE.LIGHTSOURCE_BODY,
      0.9,
    );
    arrow.setOrigin(0.5);
    arrow.setRotation({ N: -Math.PI / 2, S: Math.PI / 2, E: 0, W: Math.PI }[direction]);
    const dirVec = { N: [0, -1], S: [0, 1], E: [1, 0], W: [-1, 0] }[direction];
    arrow.x = dirVec[0]! * arrowOffset;
    arrow.y = dirVec[1]! * arrowOffset;

    this.add([outerHalo, midHalo, body, core, arrow]);
    scene.add.existing(this);
  }
}
